/*
 * Bundle Gift Reconciler
 *
 * The bundle-builder section adds books + gifts in a single ATC request,
 * stamping each line with `_bundleId` and `_bundle_role` (book|gift).
 * If a customer later removes book lines individually from the cart, the
 * paired gift lines have no UI to delete (by design) and would otherwise
 * stick in the cart forever.
 *
 * This script watches the cart on load and after every mutation, and
 * removes any gift line whose paired books no longer meet the gift's
 * threshold (tote >=2 books, mug >=3, hat >=4).
 */
(function () {
  var THRESHOLDS = { tote: 2, mug: 3, hat: 4 };
  var inFlight = false;

  function getProps(item) {
    return (item && item.properties) || {};
  }

  function indexBundles(cart) {
    var bundles = {};
    (cart.items || []).forEach(function (item) {
      var props = getProps(item);
      var bid = props._bundleId;
      if (!bid) return;
      if (!bundles[bid]) bundles[bid] = { bookQty: 0, gifts: [] };
      if (props._bundle_role === 'book') {
        bundles[bid].bookQty += item.quantity;
      } else if (props._bundle_role === 'gift') {
        bundles[bid].gifts.push(item);
      }
    });
    return bundles;
  }

  function findOrphans(bundles) {
    var updates = {};
    Object.keys(bundles).forEach(function (bid) {
      var bundle = bundles[bid];
      bundle.gifts.forEach(function (gift) {
        var props = getProps(gift);
        var giftKey = props._bundle_gift || '';
        var required = THRESHOLDS[giftKey] || 1;
        if (bundle.bookQty < required) updates[gift.key] = 0;
      });
    });
    return updates;
  }

  function reconcile() {
    if (inFlight) return;
    inFlight = true;

    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items) || !cart.items.length) return null;
        var updates = findOrphans(indexBundles(cart));
        if (!Object.keys(updates).length) return null;
        try { if (typeof window.blindlyTrack === 'function') window.blindlyTrack('cart_gift_removed', { line_keys: Object.keys(updates).slice(0, 10), count: Object.keys(updates).length, item_count: cart.item_count }); } catch (e) { /* noop */ }
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (r) { return r.ok ? r.json() : null; });
      })
      .then(function (result) {
        if (!result) return;
        // Removed something — refresh visible cart UI.
        // On /cart the items are server-rendered, so just reload. Elsewhere
        // the mini-cart drawer listens for cart:refresh.
        if (window.location.pathname === '/cart') {
          window.location.reload();
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      })
      .catch(function (e) {
        try { if (typeof window.blindlyTrack === 'function') window.blindlyTrack('cart_reconcile_failed', { which: 'bundle-gift', message: String(e && e.message || e).slice(0, 200) }); } catch (err) { /* noop */ }
        console.error('[bundle-gift-reconciler]', e);
      })
      .finally(function () {
        inFlight = false;
      });
  }

  function init() {
    reconcile();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
        if (data && data.source === 'bundle-gift-reconciler') return;
        reconcile();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
